import Alys_80b from '../assets/images/sides/Alys_80b.png';
import Bianca97 from '../assets/images/sides/Bianca97.png';
import Bianca111b from '../assets/images/sides/Bianca111b.png';
import Kris_36c from '../assets/images/sides/Kris_36c.png';
import Kris_33a from '../assets/images/sides/Kris_33a.png';
import Rico_1b from '../assets/images/sides/Rico_1b.png';

export const categories = [
  { id: 'all', name: 'All Products' },
  { id: 'tops', name: 'Tops' },
  { id: 'bottoms', name: 'Bottoms' },
  { id: 'outerwear', name: 'Outerwear' },
  { id: 'accessories', name: 'Accessories' },
  { id: 'limited', name: 'Limited Edition' }
];

export const textures = {
  black: { name: 'Black', color: '#000000' },
  white: { name: 'White', color: '#ffffff' },
  gray: { name: 'Gray', color: '#808080' },
  red: { name: 'Red', color: '#8b0000' },
  charcoal: { name: 'Charcoal', color: '#36454f' },
  cream: { name: 'Cream', color: '#fffdd0' }
};

export const products = [
  {
    id: 1,
    name: 'Vague Essential Tee',
    category: 'tops',
    price: 49.99,
    description: 'Classic essential t-shirt with Vague branding. Comfortable fit for everyday wear.',
    images: {
      default: Alys_80b,
      black: Alys_80b,
      white: Bianca97,
      gray: Bianca111b
    },
    textures: ['black', 'white', 'gray'],
    featured: true,
    limited: false
  },
  {
    id: 2,
    name: 'Street Hoodie',
    category: 'outerwear',
    price: 89.99,
    description: 'Premium hoodie designed for comfort and style. Features subtle Vague details.',
    images: {
      default: Kris_36c,
      black: Kris_36c,
      charcoal: Kris_33a,
      gray: Rico_1b
    },
    textures: ['black', 'charcoal', 'gray'],
    featured: true,
    limited: false
  },
  {
    id: 3,
    name: 'Cargo Pants',
    category: 'bottoms',
    price: 79.99,
    description: 'Functional cargo pants with modern streetwear aesthetic. Multiple pockets for utility.',
    images: {
      default: Bianca111b,
      black: Bianca111b,
      charcoal: Alys_80b
    },
    textures: ['black', 'charcoal'],
    featured: false,
    limited: false
  },
  {
    id: 4,
    name: 'Limited Drop: Alt Vision',
    category: 'tops',
    price: 129.99,
    description: 'Exclusive limited edition design. Unique graphics and premium materials.',
    images: {
      default: Kris_33a,
      black: Kris_33a,
      red: Rico_1b
    },
    textures: ['black', 'red'],
    featured: true,
    limited: true
  },
  {
    id: 5,
    name: 'Tank Top',
    category: 'tops',
    price: 39.99,
    description: 'Lightweight tank top perfect for layering or standalone wear.',
    images: {
      default: Rico_1b,
      black: Rico_1b,
      white: Alys_80b,
      cream: Bianca97
    },
    textures: ['black', 'white', 'cream'],
    featured: false,
    limited: false
  },
  {
    id: 6,
    name: 'Track Jacket',
    category: 'outerwear',
    price: 99.99,
    description: 'Sporty track jacket with zipper closure and side stripes.',
    images: {
      default: Bianca97,
      black: Bianca97,
      gray: Kris_36c
    },
    textures: ['black', 'gray'],
    featured: false,
    limited: false
  },
  {
    id: 7,
    name: 'Vague Beanie',
    category: 'accessories',
    price: 24.99,
    description: 'Warm beanie with embroidered Vague logo. Perfect for colder weather.',
    images: {
      default: Alys_80b,
      black: Alys_80b,
      gray: Bianca111b,
      cream: Kris_33a
    },
    textures: ['black', 'gray', 'cream'],
    featured: false,
    limited: false
  },
  {
    id: 8,
    name: 'Joggers',
    category: 'bottoms',
    price: 69.99,
    description: 'Comfortable joggers with tapered fit. Ideal for casual or active wear.',
    images: {
      default: Kris_36c,
      black: Kris_36c,
      charcoal: Rico_1b,
      gray: Bianca97
    },
    textures: ['black', 'charcoal', 'gray'],
    featured: false,
    limited: false
  },
  {
    id: 9,
    name: 'Art Collection Tee',
    category: 'tops',
    price: 59.99,
    description: 'Wearable art piece featuring exclusive artwork. Limited print run.',
    images: {
      default: Rico_1b,
      black: Rico_1b,
      white: Bianca111b
    },
    textures: ['black', 'white'],
    featured: true,
    limited: true
  },
  {
    id: 10,
    name: 'Crew Neck Sweater',
    category: 'tops',
    price: 84.99,
    description: 'Soft crew neck sweater for layering. Made with premium materials.',
    images: {
      default: Bianca111b,
      black: Bianca111b,
      gray: Kris_33a,
      cream: Alys_80b
    },
    textures: ['black', 'gray', 'cream'],
    featured: false,
    limited: false
  },
  {
    id: 11,
    name: 'Vague Cap',
    category: 'accessories',
    price: 34.99,
    description: 'Adjustable cap with Vague logo. Structured front panel.',
    images: {
      default: Kris_36c,
      black: Kris_36c,
      gray: Rico_1b
    },
    textures: ['black', 'gray'],
    featured: false,
    limited: false
  },
  {
    id: 12,
    name: 'Oversized Hoodie',
    category: 'outerwear',
    price: 94.99,
    description: 'Relaxed fit oversized hoodie. Perfect for that laid-back streetwear look.',
    images: {
      default: Alys_80b,
      black: Alys_80b,
      charcoal: Bianca97
    },
    textures: ['black', 'charcoal'],
    featured: false,
    limited: false
  }
];

